<script>
/**
 * ResponsiveSplit
 * ---------------------------------------------------------------------------
 * Layout de dos paneles para las pantallas densas tipo POS / taller
 * (NuevaVenta, ProcesarVenta, DiagnosticoReparacion, etc.):
 *   - En desktop (>= lg): los dos paneles van lado a lado.
 *   - En tablet/móvil (< lg): se APILAN verticalmente (primary arriba).
 *
 * Reemplaza los `<div class="col">...</div><div class="col">...</div>` que no
 * refluyen. Es puramente presentacional: el contenido (tablas, totales,
 * botoneras de pago) se pasa por los slots sin tocar su lógica.
 *
 * Slots:
 *   `primary`  -> panel principal (ej. detalle de productos / formulario).
 *   `secondary`-> panel lateral (ej. totales, métodos de pago, resumen).
 *
 * Props:
 *   ratio    -> reparto en desktop: '8-4' | '7-5' | '6-6' | '9-3'. Default '8-4'.
 *   stackAt  -> breakpoint en que apila ('md' | 'lg' | 'xl'). Default 'lg'.
 *   secondaryFirst -> en móvil muestra el panel secundario arriba.
 */
const RATIOS = {
  "9-3": [9, 3],
  "8-4": [8, 4],
  "7-5": [7, 5],
  "6-6": [6, 6],
};

export default {
  name: "ResponsiveSplit",
  props: {
    ratio: {
      type: String,
      default: "8-4",
      validator: (v) => Object.keys(RATIOS).includes(v),
    },
    stackAt: {
      type: String,
      default: "lg",
      validator: (v) => ["md", "lg", "xl"].includes(v),
    },
    secondaryFirst: { type: Boolean, default: false },
  },
  computed: {
    upBp() {
      // breakpoint a partir del cual va lado a lado
      return this.stackAt; // col-{bp}-N aplica desde ese bp hacia arriba
    },
    primaryClasses() {
      const [p] = RATIOS[this.ratio];
      return ["col-12", `col-${this.upBp}-${p}`];
    },
    secondaryClasses() {
      const [, s] = RATIOS[this.ratio];
      const order = this.secondaryFirst ? "order-first" : "";
      return ["col-12", `col-${this.upBp}-${s}`, order, `order-${this.upBp}-last`];
    },
  },
};
</script>

<template>
  <div class="row rwd-split g-3">
    <div :class="primaryClasses" class="rwd-split__primary">
      <slot name="primary" />
    </div>
    <div :class="secondaryClasses" class="rwd-split__secondary">
      <slot name="secondary" />
    </div>
  </div>
</template>
